import { getDomainConfig, getLocale } from '@raisin/cp-utils';
export const deMenus = () => {
    const basePath = getDomainConfig(getLocale('de-DE').cmsFormat).basePath;
    return {
        type: 'public',
        logoItems: [
            {
                id: '3f7573d4-7cce-42d0-8263-f0d9079e2b11',
                href: `${basePath}/`,
                url: basePath
                    ? 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/bltb82e5f4f2a225d83/raisin-logo.svg'
                    : 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/blte1a2093713009033/weltsparen-logo.svg',
                alt: 'WeltSparen',
            },
        ],
        navItems: [
            {
                id: '7c70fbcc-4e00-4fe1-8b47-87251d3534b5',
                title: 'Sparen',
                href: '',
                subMenus: {
                    main: [
                        {
                            id: '9d42c71e-7190-4618-b581-38951fbcf547',
                            type: 'advanced',
                            title: 'Tagesgeld',
                            href: `${basePath}/tagesgeld/`,
                            description: 'Flexible Einlage ohne feste Laufzeit und mit variablem Zinssatz',
                            icon: 'overnightMoneyIcon',
                            iconColor: '#9CD3E4',
                        },
                        {
                            id: '76d1f169-c6a1-495e-a495-5fcc74f131ca',
                            type: 'advanced',
                            title: 'Festgeld',
                            href: `${basePath}/festgeld/`,
                            description: 'Einlage mit fester Laufzeit und festem Zinssatz',
                            icon: 'fixedDepositIcon',
                            iconColor: '#61AFD2',
                        },
                        {
                            id: '15d1f169-c6a2-495e-a495-5fcc74f131cn',
                            type: 'advanced',
                            title: 'Nachhaltiges Festgeld',
                            href: `${basePath}/festgeld/nachhaltig/`,
                            description: 'Einlagen mit festem Zinssatz, die in verantwortungsvolle Projekte fließen',
                            icon: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/blt219a2d014c4f51f6/sustainable-deposit-badge-green.svg',
                            iconColor: '#9CD3E4',
                        },
                        {
                            id: '7c436554-958b-4bbd-91b7-fa38a9c0dada',
                            type: 'advanced',
                            title: 'Kündigungsgeld',
                            href: `${basePath}/kuendigungsgeld/`,
                            description: 'Einlage ohne feste Laufzeit mit variablem Zinssatz und Kündigungsfrist',
                            icon: 'terminationPaymentIcon',
                            iconColor: '#317EA6',
                        },
                        {
                            id: '94a44ecc-64e4-481e-96fe-3f416273313c',
                            type: 'advanced',
                            title: 'Zinsportfolio',
                            href: `${basePath}/zinsportfolio/`,
                            description: 'Flexibel sparen am Geldmarkt mit Zinsoptimierung',
                            icon: 'etfRoboIcon',
                            iconColor: '#FBC02D',
                        },
                    ],
                    sidebar: [
                        {
                            id: '948a7d90-538e-4810-98a5-cb62b90055e4',
                            type: 'image',
                            title: 'Finanztest Festgeldvergleich',
                            href: `${basePath}/festgeld/finanztest/`,
                            imageUrl: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/bltb9eb31e6bcd69b34/Image_Tagesgeld-Vergleich.png',
                            description: 'Festgeld Festgeldvergleich',
                        },
                    ],
                },
            },
            {
                id: '36e9994f-8c35-4d1c-a470-fab6ad144699',
                title: 'Investieren',
                href: '',
                subMenus: {
                    main: [
                        {
                            id: 'd71e82d5-84ea-4457-8cfc-762927bd8f21',
                            type: 'advanced',
                            title: 'Vermögensverwaltung',
                            href: `${basePath}/vermoegensverwaltung/`,
                            description: 'Automatisiert in ein von Experten entwickeltes, globales Portfolio investieren',
                            icon: 'etfRoboIcon',
                            iconColor: '#FBC02D',
                        },
                        {
                            id: 'c27ec91f-6a65-476b-9b15-ab821362f573',
                            type: 'advanced',
                            title: 'ETF Rürup',
                            href: 'https://www.raisin-pension.de/',
                            description: 'Mit Steuervorteilen für das Alter vorsorgen',
                            icon: 'etfRurupIcon',
                            iconColor: '#AEC962',
                        },
                    ],
                    sidebar: [
                        {
                            id: 'b707a878-84f0-4fdd-a07d-b4772119139b',
                            type: 'image',
                            title: 'Geldanlage mit ETFs',
                            href: `${basePath}/geldanlage/etf/`,
                            imageUrl: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/blt22269cb5ee902650/Image_Geldanlage.png',
                            description: 'Geldanlage mit ETFs',
                        },
                        {
                            id: 'efe277ff-d6e0-451a-8130-dbc8278f4862',
                            type: 'arrow',
                            title: 'Aktienwissen',
                            href: `${basePath}/geldanlage/aktien/`,
                        },
                        {
                            id: 'c9b48d1c-e9bb-435f-951e-0f02d46ab21f',
                            type: 'arrow',
                            title: 'Anleihenwissen',
                            href: `${basePath}/geldanlage/anleihen/`,
                        },
                        {
                            id: '85bec19f-5388-496f-861a-d99ba0284299',
                            type: 'arrow',
                            title: 'Kryptowährungen',
                            href: `${basePath}/geldanlage/kryptowaehrung/`,
                        },
                    ],
                    bottom: [
                        {
                            id: '2fdc2949-f54b-479e-b814-fa774fb9888a',
                            type: 'arrow',
                            title: 'Alle Investmentprodukte anzeigen',
                            href: `${basePath}/investieren/`,
                        },
                    ],
                },
            },
            {
                id: 'f149e12f-3a9f-44e3-a75e-ae1a37e12c64',
                title: 'Finanzwissen',
                href: '',
                subMenus: {
                    main: [
                        {
                            id: 'e78780a1-cc15-45d9-95ca-53c52e905cc5',
                            type: 'advanced',
                            title: 'Sparen',
                            href: `${basePath}/sparen/`,
                            description: 'Höhere Zinsen als bei der Hausbank erhalten, inkl. nationaler Einlagensicherung',
                            icon: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/bltf266390c18780027/Sparen.svg',
                            iconColor: '#0E6CC5',
                        },
                        {
                            id: '2a134210-7e96-4614-b940-318c010b7a0a',
                            type: 'advanced',
                            title: 'Geldanlage',
                            href: `${basePath}/geldanlage/`,
                            description: 'Wertschwankungen in Kauf nehmen, um langfristig höhere Renditen zu realisieren',
                            icon: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/blt928de307dda49550/Geldanlage.svg',
                            iconColor: '#0E6CC5',
                        },
                        {
                            id: '2b134250-7e96-4645-b940-318c010b8a0a',
                            type: 'advanced',
                            title: 'Nachhaltige Geldanlage',
                            href: `${basePath}/nachhaltige-geldanlage/`,
                            description: 'Von langfristigen Wachstumschancen profitieren, die auf nachhaltigen Standards basieren',
                            icon: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/blte38c0dd9a50682c2/sustainable-deposit-badge-blue.svg',
                            iconColor: '#0E6CC5',
                        },
                        {
                            id: 'd63e6408-738b-4d6f-927a-bc2274804d69',
                            type: 'advanced',
                            title: 'Steuerinformationen',
                            href: `${basePath}/steuern/`,
                            description: 'Informationen zur steuerlichen Behandlung von Geldanlagen',
                            icon: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/blt36b69e61c2b0a979/Steuerinformation.svg',
                            iconColor: '#0E6CC5',
                        },
                        {
                            id: '5d4de868-91cd-42cc-9358-08173aa5986f',
                            type: 'advanced',
                            title: 'Einlagensicherung',
                            href: `${basePath}/einlagensicherung/`,
                            description: 'Alles zum harmonisierten Einlagensicherungssystem in Europa',
                            icon: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/bltdc24d5d258f982e7/Einlagensicherung.svg',
                            iconColor: '#0E6CC5',
                        },
                    ],
                    sidebar: [
                        {
                            id: '682a68af-d0c3-4f6f-8aa4-0b4752040b0e',
                            type: 'image',
                            title: 'Geldanlagen im Ausland',
                            href: `${basePath}/geldanlage/ausland/`,
                            imageUrl: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/blt2583321398710b00/Image_Ausland.png',
                            description: 'Geldanlage im Ausland',
                        },
                        {
                            id: 'f10ea65e-7827-42c9-a681-c0b214aeb11d',
                            type: 'arrow',
                            title: 'Fonds vs. ETFs',
                            href: `${basePath}/geldanlage/etf/unterschied-fonds-etf/`,
                        },
                        {
                            id: '94216326-d1cb-4afe-9e1e-543421f52d57',
                            type: 'arrow',
                            title: 'Steuern sparen',
                            href: `${basePath}/steuer/steuern-sparen/`,
                        },
                        {
                            id: '6f4a40db-578f-4f8f-becc-cd50da44efb4',
                            type: 'arrow',
                            title: 'Was bedeutet AWV-Meldepflicht?',
                            href: `${basePath}/faq/bedeutet-awv-meldepflicht/`,
                        },
                        {
                            id: '88688bb5-71d1-49a5-a794-aecc6ee9c41e',
                            type: 'arrow',
                            title: 'Was ist die Quellensteuer?',
                            href: `${basePath}/steuer/quellensteuer/`,
                        },
                    ],
                },
            },
            {
                id: 'b1ef9202-f58c-4f98-a3fe-b4178a842ecb',
                title: 'Hilfe',
                href: '',
                subMenus: {
                    main: [
                        {
                            id: 'f7c75a69-3287-483f-912f-d4c2432a0708',
                            type: 'text',
                            title: 'So funktioniert’s',
                            href: `${basePath}/so-funktionierts/`,
                        },
                        {
                            id: 'b16af5c5-2320-4317-80fa-fc2a375eb79c',
                            type: 'text',
                            title: 'Banken',
                            href: `${basePath}/bank/`,
                        },
                        {
                            id: 'd41882ea-f390-47ed-b94e-3f7a7eea1a33',
                            type: 'text',
                            title: 'Häufig gestellte Fragen',
                            href: 'https://kundenservice.weltsparen.de/hc/de/',
                        },
                        {
                            id: '576cb97f-57f8-4236-ae70-87fb4a470e00',
                            type: 'text',
                            title: 'Kundenservice',
                            href: `${basePath}/kontakt/`,
                        },
                    ],
                },
            },
        ],
        actionItems: [
            {
                id: '659be2f1-cdfa-4666-bcbb-edf874ad83ce',
                title: 'Anmelden',
                href: `${basePath}/login/`,
                type: 'login',
            },
            {
                id: 'fc1573f6-a151-4299-aaef-0e1b375227ba',
                title: 'Registrieren',
                href: `${basePath}/register/`,
                type: 'registration',
            },
        ],
    };
};
//# sourceMappingURL=deMenus.js.map